/**
 * Mapeia a quantidade de dias de atraso para uma cor específica.
 *
 * @param {number} delayedDays - O número de dias de atraso.
 * @returns {string} A cor correspondente ao número de dias de atraso, incluindo estilos CSS opcionais.
 *
 * @example
 * // Retorna 'color: #177178;'
 * setDelayedDaysColor(5);
 *
 * @example
 * // Retorna 'color: blue; font-weight: 700;'
 * setDelayedDaysColor(15);
 */
export function setDelayedDaysColor(delayedDays) {
  const delayedDaysColorMapper = [
    { maxDays: 10, color: 'color: #177178;' },
    { maxDays: 29, color: 'color: blue; font-weight: 700;' },
    { maxDays: 44, color: 'color: green; font-weight: 700;' },
    { maxDays: 59, color: 'color: red; font-weight: 700;' },
    { maxDays: 74, color: 'color: #50C4ED; font-weight: 700;' },
    { maxDays: Infinity, color: 'color: purple; font-weight: 700;' },
  ];
  const { color } = delayedDaysColorMapper.find(
    ({ maxDays }) => delayedDays <= maxDays,
  );
  return color;
}
